import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Modal from './Modal'

import Button from '@components/button/Button'

interface AlertButton {
  color?: ButtonColor
  label: string
  onClick: () => void
  disabled?: boolean
}

interface Props {
  buttons?: AlertButton[]
  description?: string
  renderContent?: () => React.ReactNode
  title?: string
  columnButtons?: boolean
  cancel?: boolean
  closeCallback?: () => void
}

const SimpleAlertContent = ({ renderContent, buttons, description, title, columnButtons }: Props) => {
  const renderAlertButton = (button: AlertButton, index: number, list: AlertButton[]) => (
    <ButtonContainer
      key={button.label}
      isFirst={index === 0}
      isLast={index === list.length - 1}
      columnButtons={columnButtons}>
      <Button
        status={button.disabled ? 'disabled' : 'active'}
        label={button.label}
        onClick={button.onClick}
        color={button.color}
      />
    </ButtonContainer>
  )

  return (
    <ModalContent>
      {!!title && <ModalTitle>{title}</ModalTitle>}
      {!!description && <ModalDescription>{description}</ModalDescription>}
      {!!renderContent && renderContent()}
      {!!buttons && <Buttons columnButtons={columnButtons}>{buttons.map(renderAlertButton)}</Buttons>}
    </ModalContent>
  )
}

const SimpleAlert = {
  open: (props: Props) => {
    // Petit timeout pour s'assurer qu'on ouvre bien la modal après avoir
    // fermé l'éventuelle précédente
    setTimeout(
      () =>
        Modal.open({
          Content: () => <SimpleAlertContent {...props} />,
          position: props.columnButtons ? 'bottom' : undefined,
          cancel: props.cancel,
          root: 'alert_root',
          closeCallback: props.closeCallback,
        }),
      100
    )
  },
  close: () => Modal.close('alert_root'),
}

export default SimpleAlert

const ModalContent = styled(View)`
  width: 300px;
  border-radius: 4px;
  padding: 24px 0 16px;
  background-color: ${(props) => props.theme.colors.background};
`
const ModalTitle = styled(Text)`
  ${(props) => props.theme.fonts.Title3};
  padding: 0 16px 24px;
  text-align: center;
`
const ModalDescription = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  padding: 0 16px;
`
const ButtonContainer = styled(View)<{ isFirst: boolean; isLast: boolean; columnButtons?: boolean }>`
  ${(props) => !props.columnButtons && 'flex: 1;'}
  ${(props) => !props.columnButtons && !props.isFirst && 'margin-left: 4px;'}
  ${(props) => !props.columnButtons && !props.isLast && 'margin-right: 4px;'}
  ${(props) => props.columnButtons && 'margin-bottom: 12px;'}
`
const Buttons = styled(View)<{ columnButtons?: boolean }>`
  ${(props) => !props.columnButtons && 'flex-direction: row;'}
  padding: 24px 16px 0;
`
